
/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './CountryCodeDropdownList.css';

import countrySelectors from 'redux/reduxStore/lists/country';

import { InlineSelectInput } from 'components/common/SelectInput';

function makeOption(option, intl) {
  const text = option.labelId ? intl.formatMessage({ id: option.labelId }) : option.label;
  return (
    <option key={option.value} value={option.value} disabled={option.isDisabled}>{text}</option>
  );
}

function mapStateToProps(state, routerProps) {
  const { intl } = routerProps;

  return {
    countryOptions: countrySelectors.getCollection(state)
      .map((c) => ({ labelId: c.key, value: c.iso2 }))
      .sort((a, b) => {
        const firstCountryName = intl.formatMessage({ id: a.labelId });
        const secondCountryName = intl.formatMessage({ id: b.labelId });
        return firstCountryName < secondCountryName ? -1 : 1;
      }),
  };
}

const CountryCodeDropdownList = (props) => {
  const options = props.countryOptions.map((v) => makeOption(v, props.intl));

  return (
    <div className={`cmp-dropdownlist-inline`} style={props.style}>
      <label htmlFor={props.name}>
        {props.label}
      </label>

      <InlineSelectInput
        htmlId="iso2_code"
        options={options}
        value={props.value}
        onChange={props.onChange}
        className="theme-group accent color"
      />
    </div>
  );
}
CountryCodeDropdownList.propTypes = {
  countryOptions: PropTypes.array.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.any,
};

export default injectIntl(connect(mapStateToProps)(CountryCodeDropdownList));
